import {Component, HostBinding, Input, OnInit} from '@angular/core';
import { _ } from '~shared/utils';

@Component({
  selector: 'qm-loading-empty',
  templateUrl: './loading-empty.component.html',
  styleUrls: ['./loading-empty.component.scss']
})
export class LoadingEmptyComponent implements OnInit {

  @HostBinding('class') classes = 'loading-container';

  public emptyMsg = _('Service answer is empty');

  constructor() { }

  ngOnInit() {
  }

}
